<style lang="scss" scoped>
	@import "./bondSubscriptionBuy.css";
	#fundSubscription {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
<style>
  *, *::before, *::after{
      font-family: 'element-icons';

  }
  .confirmbtn{
      color: #FFFFFF !important;
      background-color: #09666e!important;
      border-color: #09666e!important;
  }
  .el-button--small:hover{
      background-color: #ffffff ;
      border-color: #dcdfe6 ;
      color: #000;
  }
</style>
<template>
	<div id="fundSubscription">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row style="display: flex;align-items: center;">
					<a-col :xl="{ span: 24 }">
						<a-row>
							<a-col :xl="{ span: 4 }">
								<a-form-model-item label="產品名稱 " class="formItem">
									<a-input v-model="params.product_name" placeholder="請輸入產品名稱"  @change="handleClear(1)" :allowClear="true" />
									<!-- <Situationall v-model="params.product_name" :url='$api.getParamList' :route1="routeFlag"
										:params='{"type":"industrys"}' :style='"width:100%"' :placeholder="'請選擇上市行業'">
									</Situationall> -->
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 4 }">
								<a-form-model-item label="產品編號" class="formItem">
									<a-input v-model="params.product_code" placeholder="請輸入產品編號"  :allowClear="true" @change="handleClear(2)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 4 }">
								<a-form-model-item label="風險評級" class="formItem">
									<a-select v-model="params.risk_type" placeholder="請選擇風險評級" @change="fengxian()">
										<a-select-option v-for="(item) in khtypeArr" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="提交時間" class="formItem">
									<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 3 }"
								style="display: inline-flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div v-if="false">
					<a-button v-if='editFund' class="bottomBtn" style="background-color:#ffa647;" @click='isopen = true,fundFlag = 1'>
						<img src="../../image/icon_tianjia.png" class="btnIcon" />
						<span>添加</span>
					</a-button>
					<a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
						class="avatar-uploader" :show-upload-list="false" :action="$api.importFundSubscription"
						:before-upload="beforeUpload" @change="handleChange">
						<a-button v-if='editFund' class="bottomBtn" style="background-color:rgb(88, 133, 234);">
							<img src="../../image/icon_daochu.png" class="btnIcon" />
							<span>導入</span>
						</a-button>
					</a-upload>
					<a-button  v-if='firstLevelFund' class="bottomBtn" style="background-color:#ed4849;" @click="handDelect">
						<img src="../../image/icon_shanchu.png" class="btnIcon" />
						<span>刪除</span>
					</a-button>
					<a-button class="bottomBtn" style="background-color:#3bc7a1;" @click="upClick()" v-if='firstLevelFund'>
						<img src="../../image/icon_word.png" class="btnIcon"/>
						<span>導出</span>
					</a-button>
				</div>

				<task :params='params' @child='fandfn'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.8rem;"></span>
				<!-- 风险评级 -->
				<!-- <div slot="risk_type" slot-scope="record">
					<div v-if="record.risk_type">{{ khtypeArr[record.risk_type].text }}</div>
				</div> -->
				<!-- 显示状态 -->
				<div slot="review_nodes" slot-scope="record">
					<div class="tableRowView1">
						<img :src="record.review_nodes > 0||record.review_nodes == 1 ? icon_one : icon_one1" alt="" class="imageC">
						<div class="lineC" :style="(record.review_nodes > 0 || record.review_nodes == 1) && record.handle != 2? 'background:#467fff;' : ''">
							<span v-if="record.handle == 2" class="redX">x</span>
						</div>
						<img :src="(record.review_nodes > 1||(record.review_nodes > 1&&record.handle == 1)) && record.review_nodes != 3 ? icon_two : icon_two1" alt="" class="imageC">
						<div class="lineC" :style="(record.review_nodes > 1||(record.review_nodes > 1&&record.handle == 1)) && record.review_nodes != 3? 'background:#6cce68;' : ''">
						</div>
						<img :src="(record.review_nodes > 1||(record.review_nodes > 1&&record.handle == 1)) && record.review_nodes != 3 ? icon_three : icon_three1" alt="" class="imageC">
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div class="popoverView" style="margin-left: 0;">
							<img :src="record.visible_bold ? icon_pdf1 : icon_pdf" class="imageC" @click='isopen = true,fundFlag = 2,addList=record'>
						</div>
						<div class="popoverView">
							<img :src="record.shShowBol ? icon_bianji1 : icon_bianji" class="imageC" @click='isopens = true,addLists=record'>
						</div>
						<!-- <div class="popoverView popoverView3">
							<pushbtn :record='record'  :params='params'></pushbtn>
						</div> -->
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
			<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<addSubscr v-if="isopen" @child='handclose' :fundFlag = fundFlag :param = addList></addSubscr>
		<fundExamine v-if="isopens" @child='hand_shenhe_close' :param = addLists></fundExamine>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>

	</div>
</template>

<script>
	import exportData from "./components/exportData";
	import App from '@/assets/app.js';
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import icon_one from '../../image/subscr/bianji.png';
	import icon_one1 from '../../image/subscr/bianji2.png';
	import icon_two from '../../image/subscr/shenhe.png';
	import icon_two1 from '../../image/subscr/bianji1.png';
	import icon_three from '../../image/icon/icon5.png';
	import icon_three1 from '../../image/icon/icon5_1.png';
	import icon_four from '../../image/icon_4.png';
	import icon_four1 from '../../image/icon_4_1.png';
	import wj_dlsfzOff from '../../image/wj_dlsfzOff.png';
	import icon_bianji from '@/image/icon_mess_1.png';
	import icon_bianji1 from '@/image/icon_mess.png';
	import wj_dz from '../../image/wj_dz.png';
	import wj_hkd from '../../image/wj_hkd.png';
	import wj_hksfzOff from '../../image/wj_hksfzOff.png';
	import wj_hz from '../../image/wj_hz.png';
	import wj_sfzOn from '../../image/wj_sfzOn.png';
	import wj_wgsfzOff from '../../image/wj_wgsfzOff.png';
	import wj_txz from '../../image/wj_txz.png';
	import {
		saveFileToLink
	} from 'web-downloadfile';
	import pushbtn from './components/pushbtn'
	import addSubscr from './components/addSubscr'
	import fundExamine from './components/fundExamine'
	import task from './components/task.vue'
	export default {
		components: {
			pushbtn,
			addSubscr,
			fundExamine,
			exportData,
			task
		},
		data() {
			return {
				pdfShow:false,
				allurl: '',
				pdfBolUrl: '',
				upFlag:false,
				addList:'',
				addLists:'',
				fundFlag:1,
				ishandout:false,
				icon_bianji,
				icon_bianji1,
				icon_pdf,
				icon_pdf1,
				isopen: false,
				isopens: false,
				icon_fasong: require('@/image/icon_fasong.png'),
				icon_hot: require('@/image/icon_hot.png'),
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				icon_four,
				icon_four1,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限     审批管理员 ipoAduitAdmin 审批权限
				firstLevelFund: this.$store.state.rolesdata.indexOf('firstLevelFund') >= 0,
				editFund: this.$store.state.rolesdata.indexOf('editFund') >= 0,
				// ipoAdmin3 比 之前的權限 ipoAdmin 多出三個字符轉編輯權限
				ipoAdmin3: this.$store.state.rolesdata.indexOf('ipoAdmin3') >= 0,
				platformArr: [
					{
					value: "",
					label: "全部",
					},
					{
					value: "1",
					label: "iPhone",
					},
					{
					value: "2",
					label: "iPad",
					},
					{
					value: "3",
					label: "Android",
					},
					{
					value: "4",
					label: "Website",
					},
					{
					value: "5",
					label: "Email",
					},
					{
					value: "6",
					label: "Telephone",
					},
					{
					value: "7",
					label: "Post",
					},
					{
					value: "8",
					label: "System",
					},
				], 
				khtypeArr: [{
						text: '全部',
						value: ''
					},
					{
						text: '最低風險',
						value: 1
					},
					{
						text: '較低風險',
						value: 2
					},
					{
						text: '中等風險',
						value: 3
					},
					{
						text: '較高風險',
						value: 4
					},
					{
						text: '最高風險',
						value: 5
					},
				],
				khtypeArrs: [],
				tzPageNum: '',
				columns: [
					{
						title: '帳戶號碼',
						dataIndex: 'account',
						align: 'center',
						width: '10%',
					},
					{
						title: '帳戶名稱',
						dataIndex: 'username',
						align: 'center',
					},
					
					{
						title: '操作人員',
						dataIndex: 'operator_name',
						align: 'center',
					},
					
					{
						title: '投資取向評級',
						dataIndex: 'score',
						align: 'center',
					
					},
					{
						title: '提交時間',
						dataIndex: 'submit_time',
						align: 'center',
					},
					{
						title: '審批進度',
						dataIndex: '',
						align: 'center',
						width: '20%',
						scopedSlots: {
							customRender: 'review_nodes'
						}
					},
					{
						title: '審批時間',
						dataIndex: 'audit_time',
						align: 'center',
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionNum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					product_code: '',
					risk_type: '',
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					product_name: '', //基金名称
					begin_time: '', //認購起始日期
					end_time: '', //認購截止日期
					timeDate: [],
					mission_flag: 0
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			// this.handland("industrys")
			// this.handland("baojianr")
		},
		methods: {
			// 表格导出下载
			queryData(val){
				let brr =[];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['id']){
						brr.push(this.columnsData[ev]['id'])
					}
				})
				let url = ''
				let _this = this;
				let sort =  val == undefined ? "" : val
				url = _this.$api.exportFundSubscriptionExcel;
				url += '?token=' + _this.$store.state.token
				url += '&m=' + Date.parse(new Date())
				url += '&begin_time=' + this.params.begin_time
				url += '&end_time=' + this.params.end_time
				url += '&product_name=' + this.params.product_name
				url += '&product_code=' + this.params.product_code
				url += '&risk_type=' + this.params.risk_type
				url += '&sort=' + sort
				url += '&loginidList=' + brr.join(',')
				console.log(url);
				window.location.href = url;
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			//PDF导出按钮
			handopen(pxfs) {
				console.log("导出按钮");
				let str = this.$api.pdfs; //getUnsk
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.exportFundSubscriptionPDF;
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
				url += '&begin_time=' + this.params.begin_time
				url += '&end_time=' + this.params.end_time
				url += '&product_name=' + this.params.product_name
				url += '&product_code=' + this.params.product_code
				url += '&risk_type=' + this.params.risk_type
				url += '&sort=' + sort
				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
				//
				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
			},
			//导入按钮方法
			beforeUpload(file) {
				var fileFormat = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			upClick(){
				this.upFlag = true
			},
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.handopen(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			fengxian(){
				this.messLoad()
			},
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1) {
					if (!this.params.product_name) {
						this.messLoad()
					}
				}
				if (val == 2) {
					if (!this.params.product_code) {
						this.messLoad()
					}
				}
				
            },

			fandfn(val){
				this.params.review_nodes = ''
				if(val == 'back'){
					this.params.mission_flag = 0
					this.params.review_nodes = ''
					this.params.status_cn=''
				}else{
					this.params.mission_flag = 1
					this.params.review_nodes = val
					this.params.status_cn=val
				}
				this.messionEvent()
			},
			handDelect() {
				if (this.selectedRows.length > 0) {
					this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
						confirmButtonText: "確認",
						cancelButtonText: "取消",
						confirmButtonClass: "confirmbtn",//自定义class
						type: "warning"
					}).then(() => {
						let dlist = []
						this.selectedRows.map(ev => {
							dlist.push({id:this.columnsData[ev].id,type:this.columnsData[ev].type})
						})
						console.log(dlist,"删除111111111");
						this.$ajax({
							method: 'post',
							url: this.$api.deleteFundById,
							headers: {
								token: this.$store.state.token
							},
							data: {
								"token": this.$store.state.token,
								"idList": dlist
							}
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.selectedRows = []
								this.messLoad();
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
						next()
					}).catch(() => {
					})

					
				} else {
					App.oTool.warningT("請選擇一條數據刪除!");
				}
				// this.$ajax({
				// 	method: 'post',
				// 	url: this.$api.deleteFundById,
				// 	headers: {
				// 		token: this.$store.state.token
				// 	},
				// 	data: {
						
				// 	}
				// }).then(res => {
				// 	if (res.data.qmiscode === 1000) {
						
				// 	} else {
				// 		App.oTool.warningT(res.data.qmismsg);
				// 	}
				// }).catch(err => {
				// 	console.log(err);
				// });
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
	
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begin_time = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]._d) : '',
				//認購截止日期
				this.params.end_time = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]._d) : ''
				if (this.params.timeDate.length<=0) {
					this.messLoad()
				}
			},


			messLoad() {
				this.$ajax({
					method: 'post',
					url: this.$api.getBondSubscriptionBuy,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.records
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['shShowBol'] = false;
								ev['visible_bold'] = false;
								ev['shKhadmin1Bol'] = false;
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionNum = res.data.missionNum
						if (this.params.product_name || this.params.product_code || this.params.risk_type ||this.params.begin_time ) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.mission_flag = 0;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					missionNum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					product_code: '',
					risk_type: '',
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					product_name: '', //基金名称
					begin_time: '', //認購起始日期
					end_time: '', //認購截止日期
					timeDate: [],
					mission_flag: 0
				}
				this.messLoad();
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},


			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
			handclose(){
				this.isopen = false;
				setTimeout(() => {
					this.messLoad()
				}, 1000);
			},
			hand_shenhe_close(){
				this.isopens = false;
				this.messLoad()
			}
		},
	};
</script>
